import { getProductInventoryPairs } from '@libs/api-proxy-client';
import type { Inventory } from '@libs/common-node';

export type FetchInventoryList = {
    sku: string;
    store: string;
}[];

export const fetchInventoryList = async (skuStorePair: FetchInventoryList): Promise<Inventory[] | undefined> => {
    try {
        return await getProductInventoryPairs(skuStorePair);
    } catch {
        // Leaving catch not to break any existing code. error response was not used anywhere
        return undefined;
    }
};
